var o="--corvaui-grid-column-count";export{o as ColumnCountCssVar};
